// DOM id on the assessment-info <form>; lets the focus-on-error effect scope its
// invalid-field lookup to this form (see FocusFirstInvalidField).
export const ASSESSMENT_INFO_FORM_ID = 'assessment-info-form';

const ASSESSMENT_DESCRIPTOR = { value: 'Assessment', label: 'Assessment' };
const EVALUATION_DESCRIPTOR = { value: 'Evaluation', label: 'Evaluation' };

export const ASSESSMENT_DESCRIPTOR_OPTIONS = [ASSESSMENT_DESCRIPTOR, EVALUATION_DESCRIPTOR];

// The descriptor a brand-new assessment starts on; an existing name parses its own.
export const DEFAULT_ASSESSMENT_DESCRIPTOR = EVALUATION_DESCRIPTOR;

export const SEASON_OPTIONS = [
    { value: 'Spring', label: 'Spring' },
    { value: 'Summer', label: 'Summer' },
    { value: 'Fall', label: 'Fall' },
    { value: 'Winter', label: 'Winter' }
];
